<kgr-modal [open]="data$ | async" (closeModal)="reset()">
  <kgr-modal-header [headline]="(data$ | async)?.title"></kgr-modal-header>
  <kgr-modal-content>
    <div class="kgr-text kgr-text--preserveLineBreaks">
      {{ (data$ | async)?.body }}
    </div>
  </kgr-modal-content>
  <kgr-modal-footer class="kgr-text kgr-text--rightAligned">
    <button class="kgr-button kgr-col" (click)="reset()" i18n="@@closeButtonLabel">Schließen</button>
    @if (data$ | async; as data) {
      <button class="kgr-button" (click)="onOpenClick(data)" i18n>Öffnen</button>
    }
  </kgr-modal-footer>
</kgr-modal>
